import { httpRequest } from '@/shared/lib/http'

export interface CompanyInfo {
  rfc: string | null
  razonSocial: string | null
  updatedAt?: string
}

interface RespuestaAjustes {
  rfc?: string | null
  razonSocial?: string | null
  updatedAt?: string
}

export const companyInfoService = {
  /** Usado en el panel admin (CompanyInfoView) */
  async get(): Promise<CompanyInfo> {
    const data = await httpRequest<RespuestaAjustes>('/admin/system-settings', {
      token: 'staff',
    })
    return {
      rfc: data?.rfc ?? null,
      razonSocial: data?.razonSocial ?? null,
      updatedAt: data?.updatedAt,
    }
  },

  /** Guardar RFC o razón social desde el panel admin */
  async update(
    data: Partial<Pick<CompanyInfo, 'rfc' | 'razonSocial'>>,
  ): Promise<CompanyInfo> {
    const res = await httpRequest<RespuestaAjustes>('/admin/system-settings', {
      method: 'PUT',
      body: JSON.stringify(data),
      token: 'staff',
    })
    return {
      rfc: res?.rfc ?? null,
      razonSocial: res?.razonSocial ?? null,
      updatedAt: res?.updatedAt,
    }
  },

  /**
   * Usado en el portal de proveedores para validar el RFC receptor al subir
   * facturas.
   *
   * El token se pide explícito y no por la ruta: el detalle de orden de compra
   * es el mismo componente para el portal y para el panel interno, así que
   * deducirlo de la URL mandaría el token equivocado.
   */
  async getForSupplier(): Promise<{ rfc: string | null; razonSocial: string | null }> {
    const data = await httpRequest<RespuestaAjustes>(
      '/suppliers/settings/company-info',
      { token: 'proveedor' },
    )
    return {
      rfc: data?.rfc ?? null,
      razonSocial: data?.razonSocial ?? null,
    }
  },
}
